module.exports = __webpack_public_path__ + "static/media/YonderMountainStringBandPageantTheater3-9-2013souvenirpennantHanddrawn3colorscreenprint.beeec799.webp";